type ExpandHandler = () => void;
const handlers = new Map<string, ExpandHandler[]>();

/**
 * Register a callback that will be invoked when attachments are added to a
 * document. Returns an unregister function. Intended for NavigationPaneContext
 * (to open the sidebar) and AttachmentList (to expand the accordion).
 */
export function registerAttachmentExpand(documentId: string, handler: ExpandHandler): () => void {
	if (!handlers.has(documentId)) handlers.set(documentId, []);
	handlers.get(documentId)!.push(handler);

	return () => {
		const arr = handlers.get(documentId);
		if (arr) {
			const idx = arr.indexOf(handler);
			if (idx >= 0) arr.splice(idx, 1);
			if (arr.length === 0) handlers.delete(documentId);
		}
	};
}

/**
 * Expand the navigation pane and attachment list for a given document.
 * Called by drop/paste handlers after successfully persisting an attachment.
 */
export function expandAttachmentPane(documentId: string): void {
	handlers.get(documentId)?.forEach((fn) => fn());
}
